import { useLoginUserStore } from '@/store';
import {
  customLog,
  LogMsgKey,
} from '@/utils';

const getAuthInfo = () => {
  try {
    const user = useLoginUserStore()?.loginUser;
    if (user) {
      return {
        id: user.id,
        role: user.role.code,
      };
    }
    return null;
  } catch (e) {
    return null;
  }
};

const getRuntimeInfo = () => ({
  user: {
    auth: getAuthInfo(),
    agent: window.navigator.userAgent,
    location: {
      domain: window.location.hostname,
      url: window.location.href,
    },
  },
});

export const logger = {
  log: (info: unknown, key: LogMsgKey) => customLog(info, key, getRuntimeInfo()),
};
